import common from "./common";
import MenuScene from "./scenes/MenuScene";
import SaveData from "./SaveData";
import GalleryScene from "./scenes/GalleryScene";
import LearnScene from "./scenes/LearnScene";
import SelectScene from "./scenes/SelectScene";
import DrawingScene from "./scenes/DrawingScene";
import CharacterScene from "./scenes/CharacterScene";
import PreloaderScene from "./scenes/PreloaderScene";
import SettingScene from "./scenes/SettingScene";
import PencilTransition from "./transitions/PencilTransition";
import TitleScene from "./scenes/TitleScene";

export default class Application {
    constructor() {
    }

    init() {
        common.saveData = new SaveData();
        common.saveData.load();

        // restore mute settings from save data
        P3.audio.mute(common.saveData.data.mute);

        this.showTitleScene();
        // this.showMenuScene();
        // this.showSelectScene();
        // this.showMenuScene();
    }

    showTitleScene() {
        const scene = new TitleScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            this.showCharacterScene();
        }, this);

        scene.signals.settings = new P3.utils.MiniSignal();
        scene.signals.settings.add(function () {
            this.showSettingScene();
        }, this);

        this.pencilTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        P3.audio.playMusic("music_splash_loop_00");

        return scene;
    }

    showMenuScene() {
        const scene = new MenuScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            this.showSelectScene();
        }, this);

        scene.signals.previous.add(function () {
            this.showGalleryScene();
        }, this);

        scene.signals.home.add(function () {
            this.showLearnScene();
        }, this);

        scene.signals.settings = new P3.utils.MiniSignal();
        scene.signals.settings.add(function () {
            this.showSettingScene();
        }, this);

        P3.audio.playMusic("music_splash_loop_00");

        this.pencilTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        return scene;
    }

    showCharacterScene() {
        P3.audio.playMusic("music_splash_loop_00");

        const scene = new CharacterScene([
            "black_hat",
            "dr_flug",
            "505",
            "demencia"
        ]);
        scene.autoAppear = true;

        scene.signals.next.add(function (characterId) {
            const json = P3.assets.json('characters');
			const name = json[characterId].name;
			const bgRevealName = json[characterId].bg_reveal;
            const staticForegroundProps = json[characterId].props;
            this.showDrawingScene(staticForegroundProps, `character_${name}`, name, json[characterId].hasProp, bgRevealName);
        }, this);

        scene.signals.previous.add(function () {
            P3.audio.playMusic("music_splash_loop_00");
            this.showTitleScene();
        }, this);

        P3.scene.show(scene);
        //scene.appear();
        // common.characters = characters;

        return scene;
    }

    showDrawingScene(staticForegroundProps, characterId, name, hasProp, bgRevealName, propExtraProperties) {
        P3.audio.playMusic("music_drawing_loop_00");

        const scene = new DrawingScene(characterId, name, hasProp, bgRevealName, propExtraProperties, staticForegroundProps);
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            this.showCharacterScene();
        }, this);

        scene.signals.previous.add(function () {
            P3.audio.playMusic("music_splash_loop_00");
            // this.showMenuScene();
            this.showCharacterScene(common.characters);
        }, this);

        this.pencilTransition(function () {
            P3.scene.show(scene);
        }, function () {
            scene.appear();
        }, this);

        return scene;
    }

    showSettingScene() {
        const scene = new SettingScene();
        scene.autoAppear = false;

        scene.signals.next.add(function () {
            P3.scene.remove(scene);
        }, this);

        P3.scene.add(scene);
        scene.appear();

        return scene;
    }

    fadeTransition(a, b, scope) {
        scope = scope || window;

        const transition = new P3.FadeTransition(0x0);
        common.transitions.addChild(transition);

        transition.signals.in.add(function () {
            transition.out();
            a && a.call(scope);
        }, this);

        transition.signals.out.add(function () {
            transition.destroy();
            b && b.call(scope);
        }, this);

        transition.in();
    }

    fadeTransitionWhite(a, b, scope) {
        scope = scope || window;

        const transition = new P3.FadeTransition(0xffffff);
        common.transitions.addChild(transition);

        transition.signals.in.add(function () {
            transition.out();
            a && a.call(scope);
        }, this);

        transition.signals.out.add(function () {
            transition.destroy();
            b && b.call(scope);
        }, this);

        transition.in();
    }

    pencilTransition(a, b, scope) {
        scope = scope || window;

        const transition = new PencilTransition(1);
        common.transitions.addChild(transition);

        transition.signals.in.add(function () {
            transition.out();
            a && a.call(scope);
        }, this);

        transition.signals.out.add(function () {
            transition.destroy();
            b && b.call(scope);
        }, this);
        transition.in();
    }

    // lazy unloading, flags all textures to be unloaded if they aren't being used
    flagAllTexturesForUnloading() {
        const resources = P3.assets._resources;
        for (let key in resources) {
            if (resources.hasOwnProperty(key)) {
                const r = resources[key];
                if (r.textures) {
                    // use first texture in sprite sheet to grab base texture, dispose of that to free up memory if its not needed
                    let t;
                    for (let k in r.textures) {
                        if (r.textures.hasOwnProperty(k)) {
                            t = r.textures[k];
                            break;
                        }
                    }
                    t && t.baseTexture.dispose();
                } else if (r.texture) {
                    // if its a bg jpeg dispose of that base texture too
                    r.texture.baseTexture.dispose();
                }
            }
        }
    }
}